<template>
  <div style="height: 100%;">
    <comm-record :type="type" :deviceId="deviceId"></comm-record>
  </div>
</template>
<script>
import commRecord from './comm-record';
export default {
  name: "other-record",
  data() {
    return {
    };
  },
  props: ['type','deviceId'],
  mounted() {

  },
  methods: {
  },
  components: { commRecord }
};
</script>



// WEBPACK FOOTER //
// src/components/riskRecord/other-record.vue